import { spacingSizes } from '@magnetic/foundation';
import { useMargin, useClassNames } from '@magnetic/hooks';
import React, { forwardRef } from 'react';
import { computeFlexWeight } from './compute.js';

const Flex = forwardRef(
  ({
    align = "stretch",
    as,
    basis = "auto",
    className,
    direction = "horizontal",
    gap = 0,
    grow = 0,
    justify = "flex-start",
    margin,
    maxWidth,
    minWidth,
    reverse = false,
    shrink = 1,
    style,
    width,
    wrap = false,
    ...rest
  }, ref) => {
    const Component = as || "div";
    const marginClassNames = useMargin(margin);
    const classNames = useClassNames("mds-flex", className, marginClassNames);
    return /* @__PURE__ */ React.createElement(Component, {
      className: classNames,
      ref,
      style: {
        ...style,
        alignItems: align,
        display: "flex",
        flexBasis: basis,
        flexDirection: `${direction === "horizontal" ? "row" : "column"}${reverse ? "-reverse" : ""}`,
        flexGrow: computeFlexWeight(grow),
        flexShrink: computeFlexWeight(shrink),
        flexWrap: wrap ? "wrap" : "nowrap",
        gap: typeof gap === "number" ? gap : spacingSizes[gap],
        justifyContent: justify,
        ...maxWidth && { maxWidth },
        ...minWidth && { minWidth },
        ...width && { width }
      },
      ...rest
    });
  }
);

export { Flex };
//# sourceMappingURL=index.js.map
